import { useEffect } from "react";
import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import EventSearch from "@/pages/home/components/EventSearch";
import LatestNews from "@/pages/home/components/LatestNews";
import SpecialEntry from "@/pages/home/components/SpecialEntry";
import PlatformIntro from "@/pages/home/components/PlatformIntro";
import { setPageSeo } from "@/utils/seo";

const stats = [
  { icon: "ri-trophy-line", value: "128", label: "累计收录赛事" },
  { icon: "ri-calendar-check-line", value: "12", label: "今日进行中" },
  { icon: "ri-group-line", value: "86", label: "参赛队伍" },
  { icon: "ri-eye-line", value: "24.6万", label: "本周浏览量" },
];

const quickCategories = [
  { name: "电子竞技", icon: "ri-gamepad-line", desc: "英雄联盟 · DOTA2 · CS2" },
  { name: "体育竞技", icon: "ri-basketball-line", desc: "篮球 · 马拉松 · 乒乓球" },
  { name: "棋牌竞技", icon: "ri-brain-line", desc: "国际象棋 · 围棋" },
  { name: "极限运动", icon: "ri-run-line", desc: "滑板 · 攀岩" },
];

export default function Home() {
  useEffect(() => {
    setPageSeo({
      title: "51每日大赛今日黑聚集地详情 - 权威赛事资讯与详细介绍",
      description:
        "51每日大赛今日黑聚集地详情网站提供最新比赛信息和赛事详情，覆盖各类每日大赛动态，是赛事爱好者了解赛况、查看比赛详情的专业平台。",
      keywords:
        "51每日大赛,今日黑聚集地,赛事详情,比赛资讯,每日赛事,赛事动态,比赛介绍,赛事信息",
    });
  }, []);

  return (
    <div className="pb-4">
      <HeroCarousel />
      <EventSearch />

      <section className="mx-auto mt-12 max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <div>
                <p className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
                  {item.value}
                </p>
                <p className="text-xs text-foreground-500 md:text-sm">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto mt-14 max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {quickCategories.map((cat) => (
            <Link
              key={cat.name}
              to={`/category?category=${encodeURIComponent(cat.name)}`}
              className="group flex items-center justify-between rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-400"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${cat.icon} text-2xl`}></i>
                </span>
                <div>
                  <p className="font-heading text-base font-bold text-foreground-950">
                    {cat.name}
                  </p>
                  <p className="mt-0.5 text-xs text-foreground-500">{cat.desc}</p>
                </div>
              </div>
              <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-accent-600"></i>
            </Link>
          ))}
        </div>
      </section>

      <LatestNews />
      <SpecialEntry />
      <PlatformIntro />
    </div>
  );
}